import * as Calendar from 'admin/time/Calendar'
import { getDefaultTimeZoneName } from 'admin/time/TimeZone'
import Api from 'api'
import * as File from 'api/file'
import * as hal from 'hal'
import {
  CONTINUITY_ARCHIVED_MESSAGE_REL,
  CONTINUITY_DOWNLOAD_REL,
  CONTINUITY_MESSAGE_REL,
  CONTINUITY_PREVIEW_REL
} from 'product/resources'
import querystring from 'querystring'
import logger from 'system/logger'
import { parseTemplate } from 'url-template'

import { toMailSearchResults } from './converters'

export const CONTINUITY_MESSAGES_CLEAR_AUTHORIZATION_COUNT =
  'CONTINUITY_MESSAGES_CLEAR_AUTHORIZATION_COUNT'
export const CONTINUITY_MESSAGES_CLEAR_DOWNLOAD_URI_TEMPLATE =
  'CONTINUITY_MESSAGES_CLEAR_DOWNLOAD_URI_TEMPLATE'
export const CONTINUITY_MESSAGES_CLEAR_NEXT_LINK = 'CONTINUITY_MESSAGES_CLEAR_NEXT_LINK'
export const CONTINUITY_MESSAGES_CLEAR_PREVIEW = 'CONTINUITY_MESSAGES_CLEAR_PREVIEW'
export const CONTINUITY_MESSAGES_CLEAR_RESULTS = 'CONTINUITY_MESSAGES_CLEAR_RESULTS'
export const CONTINUITY_MESSAGES_CLEAR_SCROLL_TO_INDEX =
  'CONTINUITY_MESSAGES_CLEAR_SCROLL_TO_INDEX'
export const CONTINUITY_MESSAGES_CLEAR_SELECTION = 'CONTINUITY_MESSAGES_CLEAR_SELECTION'
export const CONTINUITY_MESSAGES_CLEAR_SID = 'CONTINUITY_MESSAGES_CLEAR_SID'
export const CONTINUITY_MESSAGES_CLEAR_SOURCE = 'CONTINUITY_MESSAGES_CLEAR_SOURCE'
export const CONTINUITY_MESSAGES_CONCAT_RESULTS = 'CONTINUITY_MESSAGES_CONCAT_RESULTS'
export const CONTINUITY_MESSAGES_ENABLE_HIGHLIGHTING =
  'CONTINUITY_MESSAGES_ENABLE_HIGHLIGHTING'
export const CONTINUITY_MESSAGES_INIT_DB = 'CONTINUITY_MESSAGES_INIT_DB'
export const CONTINUITY_MESSAGES_SELECT_ROWS = 'CONTINUITY_MESSAGES_SELECT_ROWS'
export const CONTINUITY_MESSAGES_SET_CONTINUITY_URI =
  'CONTINUITY_MESSAGES_SET_CONTINUITY_URI'
export const CONTINUITY_MESSAGES_SET_AUTHORIZATION_COUNT =
  'CONTINUITY_MESSAGES_SET_AUTHORIZATION_COUNT'
export const CONTINUITY_MESSAGES_SET_AUTHORIZATION_TIMESTAMP =
  'CONTINUITY_MESSAGES_SET_AUTHORIZATION_TIMESTAMP'
export const CONTINUITY_MESSAGES_SET_COLUMN_WIDTH = 'CONTINUITY_MESSAGES_SET_COLUMN_WIDTH'
export const CONTINUITY_MESSAGES_SET_DATE_RANGE = 'CONTINUITY_MESSAGES_SET_DATE_RANGE'
export const CONTINUITY_MESSAGES_SET_DATE_RANGE_SHOWN =
  'CONTINUITY_MESSAGES_SET_DATE_RANGE_SHOWN'
export const CONTINUITY_MESSAGES_SET_DATE_RANGE_HIDDEN =
  'CONTINUITY_MESSAGES_SET_DATE_RANGE_HIDDEN'
export const CONTINUITY_MESSAGES_SET_DOWNLOAD_URI_TEMPLATE =
  'CONTINUITY_MESSAGES_SET_DOWNLOAD_URI_TEMPLATE'
export const CONTINUITY_MESSAGES_SET_NEXT_LINK = 'CONTINUITY_MESSAGES_SET_NEXT_LINK'
export const CONTINUITY_MESSAGES_SET_OFFSET = 'CONTINUITY_MESSAGES_SET_OFFSET'
export const CONTINUITY_MESSAGES_SET_PREVIEW = 'CONTINUITY_MESSAGES_SET_PREVIEW'
export const CONTINUITY_MESSAGES_SET_QUERY = 'CONTINUITY_MESSAGES_SET_QUERY'
export const CONTINUITY_MESSAGES_SET_RESULTS = 'CONTINUITY_MESSAGES_SET_RESULTS'
export const CONTINUITY_MESSAGES_SET_RESULTS_QUERY =
  'CONTINUITY_MESSAGES_SET_RESULTS_QUERY'
export const CONTINUITY_MESSAGES_SET_SCROLL_TO_INDEX =
  'CONTINUITY_MESSAGES_SET_SCROLL_TO_INDEX'
export const CONTINUITY_MESSAGES_SET_SID = 'CONTINUITY_MESSAGES_SET_SID,'
export const CONTINUITY_MESSAGES_SET_SOURCE = 'CONTINUITY_MESSAGES_SET_SOURCE'
export const CONTINUITY_MESSAGES_SET_TIME_ZONE_KEY =
  'CONTINUITY_MESSAGES_SET_TIME_ZONE_KEY'
export const CONTINUITY_MESSAGES_START_LOADING = 'CONTINUITY_MESSAGES_START_LOADING'
export const CONTINUITY_MESSAGES_STOP_LOADING = 'CONTINUITY_MESSAGES_STOP_LOADING'
export const CONTINUITY_MESSAGES_TOGGLE_ATTACHMENT_PANEL =
  'CONTINUITY_MESSAGES_TOGGLE_ATTACHMENT_PANEL'

const startLoading = (companyKey) => ({
  type: CONTINUITY_MESSAGES_START_LOADING,
  companyKey
})
const stopLoading = (companyKey) => ({
  type: CONTINUITY_MESSAGES_STOP_LOADING,
  companyKey
})

/// ========= INIT ========= ///

const setContinuityUri = (companyKey, continuityUri) => ({
  type: CONTINUITY_MESSAGES_SET_CONTINUITY_URI,
  companyKey,
  continuityUri
})

const initDb = (companyKey) => ({
  type: CONTINUITY_MESSAGES_INIT_DB,
  companyKey
})

export const init = (companyKey, continuityUri) => (dispatch) => {
  dispatch(initDb(companyKey))
  dispatch(setContinuityUri(companyKey, continuityUri))

  dispatch(setTimeZoneName(companyKey, getDefaultTimeZoneName()))

  const fromDate = Calendar.atMidnight().minus({ months: 1 }).toUTC().toISO()
  const thruDate = Calendar.atMidnight().toUTC().toISO()

  dispatch(setDateRange(companyKey, fromDate, thruDate))
}

/// ========= SEARCH PARAMETERS ========= ///

export const setTimeZoneName = (companyKey, timeZoneName) => ({
  type: CONTINUITY_MESSAGES_SET_TIME_ZONE_KEY,
  companyKey,
  timeZoneName
})

export const setQuery = (companyKey, query) => ({
  type: CONTINUITY_MESSAGES_SET_QUERY,
  companyKey,
  query
})

export const setDateRange = (companyKey, fromDate, thruDate) => ({
  type: CONTINUITY_MESSAGES_SET_DATE_RANGE,
  companyKey,
  fromDate,
  thruDate
})

export const setDateRangeShown = (companyKey) => ({
  type: CONTINUITY_MESSAGES_SET_DATE_RANGE_SHOWN,
  companyKey
})

export const setDateRangeHidden = (companyKey) => ({
  type: CONTINUITY_MESSAGES_SET_DATE_RANGE_HIDDEN,
  companyKey
})

/// ========= AUTHORISATION stuff ========= ///

const setAuthorizationCount = (companyKey, count) => ({
  type: CONTINUITY_MESSAGES_SET_AUTHORIZATION_COUNT,
  companyKey,
  count
})

// public for unit tests
export const clearAuthorizationCount = (companyKey) => ({
  type: CONTINUITY_MESSAGES_CLEAR_AUTHORIZATION_COUNT,
  companyKey
})

const setAuthorizationTimestamp = (companyKey, timestamp) => ({
  type: CONTINUITY_MESSAGES_SET_AUTHORIZATION_TIMESTAMP,
  companyKey,
  timestamp
})

export const authorizeOnce = (companyKey) => (dispatch) => {
  dispatch(setAuthorizationCount(companyKey, 1))
}

export const authorizeSession = (companyKey) => (dispatch) => {
  dispatch(setAuthorizationTimestamp(companyKey, Date.now()))
}

/// ========= SEARCH/RESULTS/PAGINATION ========= ///

const clearResults = (companyKey) => ({
  type: CONTINUITY_MESSAGES_CLEAR_RESULTS,
  companyKey
})

export const setResults = (companyKey, results) => ({
  type: CONTINUITY_MESSAGES_SET_RESULTS,
  companyKey,
  results
})

export const setResultsQuery = (companyKey, query) => ({
  type: CONTINUITY_MESSAGES_SET_RESULTS_QUERY,
  companyKey,
  query
})

const clearDownloadUriTemplate = (companyKey) => ({
  type: CONTINUITY_MESSAGES_CLEAR_DOWNLOAD_URI_TEMPLATE,
  companyKey
})

// public for unit tests
export const setDownloadUriTemplate = (companyKey, downloadUriTemplate) => ({
  type: CONTINUITY_MESSAGES_SET_DOWNLOAD_URI_TEMPLATE,
  companyKey,
  downloadUriTemplate
})

export const concatResults = (companyKey, moreResults) => ({
  type: CONTINUITY_MESSAGES_CONCAT_RESULTS,
  companyKey,
  moreResults
})

const setNextLink = (companyKey, nextLink) => ({
  type: CONTINUITY_MESSAGES_SET_NEXT_LINK,
  companyKey,
  nextLink
})

const clearNextLink = (companyKey) => ({
  type: CONTINUITY_MESSAGES_CLEAR_NEXT_LINK,
  companyKey
})

// public only for testability
export const setOffset = (companyKey, offset) => ({
  type: CONTINUITY_MESSAGES_SET_OFFSET,
  companyKey,
  offset
})

export const search =
  (companyKey, searchUri, viewing, parameters, timeZoneName) => async (dispatch) => {
    dispatch(startLoading(companyKey))

    const { query } = parameters

    // always set back to zero when running a new search
    const offset = 0

    dispatch(setOffset(companyKey, offset))

    try {
      // create a search resource first
      const response = await Api.post(searchUri, querystring.stringify(parameters), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })

      let results = hal.resource(response.data, CONTINUITY_MESSAGE_REL)
      let nextLink = hal.next(response.data)
      const downloadUriTemplate = hal.href(response.data, CONTINUITY_DOWNLOAD_REL)

      if (nextLink) {
        const nextResponse = await Api.post(nextLink)

        results = [...results, ...hal.resource(nextResponse.data, CONTINUITY_MESSAGE_REL)]
        nextLink = hal.next(nextResponse.data)
      }

      // set the query first before results to ensure table wont get rendered twice
      // because it will be shown only when results are set but results query can retrigger a render
      dispatch(setResultsQuery(companyKey, query))
      dispatch(setResults(companyKey, toMailSearchResults(results, { timeZoneName })))
      dispatch(setScrollToIndex(companyKey, 0))
      dispatch(setNextLink(companyKey, nextLink))
      dispatch(setDownloadUriTemplate(companyKey, downloadUriTemplate))
    } catch (err) {
      // remove any existing states to reflect error state
      dispatch(clearResults(companyKey))
      dispatch(clearDownloadUriTemplate(companyKey))
      dispatch(clearNextLink(companyKey))
      logger.error(err)
    } finally {
      if (viewing) {
        dispatch(back(companyKey)) // in case user was viewing before
      }

      dispatch(stopLoading(companyKey))
    }
  }

// technically this is prefetch.
// it behaves a bit differently when paginating a whole table or
// when viewing one entry.
export const next = (companyKey, params) => async (dispatch) => {
  const {
    timeZoneName,
    viewing,
    nextMail,
    nextLink,
    nextOffset,
    nextRelativeIndex,
    paginateNext,
    prefetch
  } = params

  if (viewing) {
    dispatch(clearAuthorizationCount(companyKey))
    await dispatch(view(companyKey, nextMail, nextRelativeIndex))
  }

  if (paginateNext) {
    // set offset to real offset increased by one limit
    dispatch(setOffset(companyKey, nextOffset))
  }

  if (!viewing) {
    dispatch(clearSelection(companyKey))
  }

  if (!prefetch) return

  dispatch(startLoading(companyKey))

  try {
    const response = await Api.post(nextLink)
    const moreResults = toMailSearchResults(
      hal.resource(response.data, CONTINUITY_MESSAGE_REL),
      {
        timeZoneName
      }
    )

    const nextNextLink = hal.next(response.data)

    dispatch(concatResults(companyKey, moreResults))
    dispatch(setNextLink(companyKey, nextNextLink))

    if (paginateNext && !viewing) {
      dispatch(setScrollToIndex(companyKey, 0))
    }
  } catch (err) {
    logger.error(err)
  } finally {
    dispatch(stopLoading(companyKey))
  }
}

// prev is always from cache
export const prev = (companyKey, params) => async (dispatch) => {
  const { viewing, prevIndex, prevMail, offset, limit } = params

  if (viewing) {
    const paginate = prevIndex < offset
    const prevRelativeIndex = paginate ? limit - 1 : prevIndex - offset

    dispatch(clearAuthorizationCount(companyKey))
    await dispatch(view(companyKey, prevMail, prevRelativeIndex))

    if (paginate) {
      dispatch(setOffset(companyKey, offset - limit))
    }
  } else {
    dispatch(setScrollToIndex(companyKey, 0))
    dispatch(setOffset(companyKey, offset - limit))
  }

  dispatch(clearSelection(companyKey))
}

export const setColumnWidth = (companyKey, columnKey, width) => ({
  type: CONTINUITY_MESSAGES_SET_COLUMN_WIDTH,
  companyKey,
  columnKey,
  width
})

/// ========= TABLE actions ========= ///

const clearScrollToIndex = (companyKey) => ({
  type: CONTINUITY_MESSAGES_CLEAR_SCROLL_TO_INDEX,
  companyKey
})

// public for unit tests
export const setScrollToIndex = (companyKey, scrollToIndex) => ({
  type: CONTINUITY_MESSAGES_SET_SCROLL_TO_INDEX,
  companyKey,
  scrollToIndex
})

const clearSelection = (companyKey) => ({
  type: CONTINUITY_MESSAGES_CLEAR_SELECTION,
  companyKey
})

const selectRows = (companyKey, rows, selected) => ({
  type: CONTINUITY_MESSAGES_SELECT_ROWS,
  companyKey,
  rows,
  selected
})

export const select = (companyKey, rows, selected) => (dispatch) => {
  dispatch(clearScrollToIndex(companyKey)) // ensures that table doesn't jump
  dispatch(selectRows(companyKey, rows, selected))
}

const setPreview = (companyKey, preview) => ({
  type: CONTINUITY_MESSAGES_SET_PREVIEW,
  companyKey,
  preview
})

const clearPreview = (companyKey) => ({
  type: CONTINUITY_MESSAGES_CLEAR_PREVIEW,
  companyKey
})

export const view = (companyKey, mail, relativeIndex) => async (dispatch) => {
  dispatch(startLoading(companyKey))

  try {
    const previewUri = hal.href(mail, CONTINUITY_PREVIEW_REL)
    let previewResponse

    if (previewUri) {
      previewResponse = await Api.get(previewUri)
    }

    // only set both at the end to ensure both appear at the same time
    dispatch(setSid(companyKey, mail.sid))
    if (previewResponse) {
      dispatch(setPreview(companyKey, previewResponse.data))
    }
  } catch (err) {
    logger.error(err)
  } finally {
    // necessary so that table's viewport scrolls to that row when going back
    dispatch(setScrollToIndex(companyKey, relativeIndex))

    dispatch(stopLoading(companyKey))
  }
}

export const back = (companyKey) => (dispatch) => {
  dispatch(clearPreview(companyKey))
  dispatch(clearSid(companyKey))
  dispatch(clearAuthorizationCount(companyKey))
}

/// ========= DETAIL VIEW actions ========= ///

export const toggleAttachmentPanel = (companyKey, expanded) => ({
  type: CONTINUITY_MESSAGES_TOGGLE_ATTACHMENT_PANEL,
  companyKey,
  expanded
})

export const setSid = (companyKey, sid) => ({
  type: CONTINUITY_MESSAGES_SET_SID,
  companyKey,
  sid
})

export const clearSid = (companyKey) => ({
  type: CONTINUITY_MESSAGES_CLEAR_SID,
  companyKey
})

/// ========= TOOLBAR actions ========= ///

export const enableHighlighting = (companyKey, enabled) => ({
  type: CONTINUITY_MESSAGES_ENABLE_HIGHLIGHTING,
  companyKey,
  enabled
})

const setSource = (companyKey, source) => ({
  type: CONTINUITY_MESSAGES_SET_SOURCE,
  companyKey,
  source
})

export const viewSource = (companyKey, rows) => async (dispatch) => {
  if (rows.length === 1) {
    dispatch(startLoading(companyKey))

    try {
      const mail = rows[0]

      const downloadUri = hal.href(mail, CONTINUITY_ARCHIVED_MESSAGE_REL)
      const response = await Api.get(downloadUri)

      dispatch(setSource(companyKey, response.data))
    } catch (err) {
      logger.error(err)
    } finally {
      dispatch(stopLoading(companyKey))
    }
  }
}

export const hideSource = (companyKey) => ({
  type: CONTINUITY_MESSAGES_CLEAR_SOURCE,
  companyKey
})

export const download = (downloadParams) => () => {
  let url
  let name
  let ext

  const { downloadUriTemplate, mail, selectedSids } = downloadParams

  if (mail) {
    // todo https://youtrack.smxemail.com/issue/SCL-2767
    url = hal.href(mail, CONTINUITY_ARCHIVED_MESSAGE_REL)
    name = mail.sid
    ext = 'eml'
  } else {
    // compose correct url for zip download based on url template which can look like
    // {href: "(removed)/customer/2000074/archiving/download{?fromDate,thruDate,query,sid*}", templated: true}

    const parsedDownloadUriTemplate = parseTemplate(downloadUriTemplate)
    url = parsedDownloadUriTemplate.expand({
      sid: selectedSids
    })
  }

  if (url) {
    return File.download(url, name, ext)
  }
}
